import { useAnimateHeight } from "@redotech/react-animation/transition";
import { useHandler } from "@redotech/react-util/hook";
import TriangleDown from "@redotech/redo-icons/triangle-down_filled.svg";
import TriangleRight from "@redotech/redo-icons/triangle-right_filled.svg";
import { memo, ReactNode, useState } from "react";
import { Flex } from "../../flex";
import { Icon } from "../../icon";
import { RedoButton } from "../buttons/redo-button";

export const RedoCollapseSubsection = memo(function RedoCollapseSubsection({
  children,
  title,
  tooltip,
  defaultCollapsed = true,
}: {
  children: ReactNode | ReactNode[];
  title: string;
  tooltip?: ReactNode | ReactNode[];
  defaultCollapsed?: boolean;
}) {
  const [element, setElement] = useState<HTMLElement | null>(null);
  const [animateStyles, animating] = useAnimateHeight(element);
  const [collapsed, setCollapsed] = useState(defaultCollapsed);

  const onClick = useHandler(() => setCollapsed((value) => !value));

  const leadingIcon = () => (
    <Icon
      arbiterIconSvg={collapsed ? TriangleRight : TriangleDown}
      color="ghost"
      style={{ width: 14, height: 14 }}
    />
  );

  return (
    <Flex dir="column">
      <Flex>
        <RedoButton
          color="gray"
          hierarchy="link"
          IconLeading={leadingIcon}
          onClick={onClick}
          size="sm"
          text={title}
        />
        {tooltip}
      </Flex>
      <Flex dir="column" ref={setElement} style={animateStyles}>
        {(animating || !collapsed) && <>{children}</>}
      </Flex>
    </Flex>
  );
});
